import { useRef, useEffect, ReactNode } from 'react'

import clsx from 'clsx'
import { PopoverMenu } from './styles'

type PopoverPops = {
  children: ReactNode
  open: boolean
  className?: string
  close: () => void
}

const Popover = ({ children, open, className, close }: PopoverPops) => {
  const ref = useRef<HTMLDivElement>(null)

  const handleClick = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      close()
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleClick, true)

    return () => {
      document.removeEventListener('click,', handleClick, true)
    }
  }, [open])

  if (!open) return null

  return (
    <PopoverMenu
      ref={ref}
      className={clsx(
        '_border _rounded-lg _d-flex _flex-column _justify-content-center _position-absolute',
        className
      )}
    >
      {children}
    </PopoverMenu>
  )
}

export default Popover
